import React from 'react';
import PropTypes from 'prop-types';

const CenteredHeaderGroup = ({ displayName }) => (
  <div style={{ textAlign: 'center', width: '100%' }}>
    {displayName}
  </div>
);

CenteredHeaderGroup.propTypes = {
  displayName: PropTypes.string,
};

export default CenteredHeaderGroup;